<script lang="ts" setup>
import type { IProps } from './home-textWithImageAndIconList.types'

defineProps<IProps>()

</script>

<template>
  <UiSection color="purple">
    <UiHeader
      :header="header"
      :subheader="subheader"
      position="center"
    />
    
    <div class="text-with-image__layout">
      <img
        class="text-with-image__img"
        :src="image"
      >

      <div class="text-with-image__content">
        <UiListWithIcons
          v-if="list"
          :list="list"
        />
        <UiButton
          v-if="button"
          :to="button.to"
        >
          {{ button.text }}
        </UiButton>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>

.section {
  :deep() {
    .ui-header {
      &__subheader {
        max-width: 88rem;
        margin: 0 auto;
        margin-top: 3.2rem;
      }
    }
  }
}
.text-with-image {

  &__layout {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 111.5rem;
    width: 100%;
    margin: 3.2rem auto 0 auto;

    @include atM {
      flex-direction: row-reverse;
      align-items: flex-start;
      gap: 8rem;
      margin: 6.4rem auto 0 auto;
    }

    @include atXL {
      gap: 16rem;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;

    .button {
      align-self: center;

      @include atM {
        align-self: flex-start;
      }
    }
  }

  &__img {
    border-radius: 1.6rem;
  }
}
</style>
